export default defineAppConfig({
  brand: "sinsay",
  test: false,
  provider: "s3",
});
